import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { selectAllStrings } from '../features/language/languageSlice';
import { useSelector } from 'react-redux';
import BuyAccessButton from '../components/BuyAccessButton';
import constants from '../constants';

const ErrorMessage = ({message, onGoBack}) => {
    const strings = useSelector(selectAllStrings);
    
    return <div className="modal" id="error_message_modal">
        <div className="modal-body" id="error_message_modal_body">
            <div className="modal-content">
                <div className="modal-header">
                    <span>{strings.ops}</span>
                </div>
                <div className="icon">
                <FontAwesomeIcon icon={faExclamationCircle}/>
                </div>
                <div className="modal-text message">{strings[message] || message}</div>
                {message == 'trial alredy used' && constants.environment == 
                        'iOS' ? <BuyAccessButton/> : null}
                <button className="btn" id="back_button" onClick={onGoBack}>{strings.back}</button>
                <div className="modal-text support">{strings.for+(constants.environment == 'iOS' ? '' : strings.write_to_info)}</div>
            </div>
        </div>
    </div>
    };
    
export default ErrorMessage;